// Action type For Payment Terms

// Get Payment Terms List
export const GET_PAYMENT_TERMS_LIST = "GET_PAYMENT_TERMS_LIST";
export const GET_PAYMENT_TERMS_LIST_SUCCESS = "GET_PAYMENT_TERMS_LIST_SUCCESS";
export const GET_PAYMENT_TERMS_LIST_FAILURE = "GET_PAYMENT_TERMS_LIST_FAILURE";

// Get Payment Terms Data
export const GET_PAYMENT_TERMS_DATA = "GET_PAYMENT_TERMS_DATA";
export const GET_PAYMENT_TERMS_DATA_SUCCESS = "GET_PAYMENT_TERMS_DATA_SUCCESS";
export const GET_PAYMENT_TERMS_DATA_FAILURE = "GET_PAYMENT_TERMS_DATA_FAILURE";

// Create Payment Terms
export const CREATE_PAYMENT_TERMS = "CREATE_PAYMENT_TERMS";
export const CREATE_PAYMENT_TERMS_SUCCESS = "CREATE_PAYMENT_TERMS_SUCCESS";
export const CREATE_PAYMENT_TERMS_FAILURE = "CREATE_PAYMENT_TERMS_FAILURE";

// Update Payment Terms
export const UPDATE_PAYMENT_TERMS = "UPDATE_PAYMENT_TERMS";
export const UPDATE_PAYMENT_TERMS_SUCCESS = "UPDATE_PAYMENT_TERMS_SUCCESS";
export const UPDATE_PAYMENT_TERMS_FAILURE = "UPDATE_PAYMENT_TERMS_FAILURE";

// Delete Payment Terms
export const DELETE_PAYMENT_TERMS = "DELETE_PAYMENT_TERMS";
export const DELETE_PAYMENT_TERMS_SUCCESS = "DELETE_PAYMENT_TERMS_SUCCESS";
export const DELETE_PAYMENT_TERMS_FAILURE = "DELETE_PAYMENT_TERMS_FAILURE";
